<template>
  <fragment>
    <tr>
      <td>
        <strong>Métodos de pagamento permitidos na quitação de contrato</strong>
      </td>
      <td>
        <checkbox-field
          label="Boleto"
          value="boleto"
          v-model="form.get('methods').value"
          :errors="form.get('methods').errors"
          @input="emitFormFieldChanged('methods')"
        />
        <checkbox-field
          label="Cartão de crédito"
          value="credit_card"
          v-model="form.get('methods').value"
          :errors="form.get('methods').errors"
          @input="emitFormFieldChanged('methods')"
        />
        <checkbox-field
          label="Pix"
          value="pix"
          v-model="form.get('methods').value"
          :errors="form.get('methods').errors"
          @input="emitFormFieldChanged('methods')"
        />
      </td>
    </tr>
  </fragment>
</template>
<script>
import { CheckboxField } from 'components/form';

export default {
  components: {
    CheckboxField,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  methods: {
    emitFormFieldChanged(field) {
      this.$emit('form-field-changed', { [field]: this.form.get(field).value });
    },
  },
};
</script>
